import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormConstructorComponent } from 'src/app/forms/form-constructors/form-constructor/form-constructor.component';
import { FormStateService } from 'src/app/forms/form-state.service';
import { MapGotoBlockContent, MapGotoBlockForm } from 'src/app/interfaces/map.interface';
import { unsubscribeAll } from '../../../../common/app.helpers';
import { GeocodingService } from '../../../../forms/fields/components/location-form-field/geocoding/geocoding.service';
import { NotificationContextAttributesService } from '../../../../notifications/notifications-context-attributes.service';
import { NotificationService } from '../../../../notifications/notifications.service';
import { MapCords } from '../../map.interfaces';

@Component({
  selector: 'app-map-goto-block',
  templateUrl: './map-goto-block.component.html',
  styleUrls: ['./map-goto-block.component.scss'],
})
export class MapGotoBlockComponent implements OnInit, OnDestroy {
  @Input({ required: true }) public mapGotoBlockContent: MapGotoBlockContent;

  @Output() public mapGotoSubmittedEvent: EventEmitter<MapGotoBlockForm> = new EventEmitter<MapGotoBlockForm>();

  @ViewChild(FormConstructorComponent, { static: false })
  private mapGotoForm: FormConstructorComponent;
  private subscriptions$: Subscription[] = [];

  private geocodingService = inject(GeocodingService);
  private formStateService = inject(FormStateService);
  private notificationService = inject(NotificationService);
  private modalAttributesService = inject(NotificationContextAttributesService);

  public ngOnInit(): void {
    this.subscribeOnLocationInputUpdated();
  }

  public ngOnDestroy(): void {
    unsubscribeAll(this.subscriptions$);
  }

  public onSubmitForm(event: Event): void {
    this.formStateService.stopAllAction(event);
    this.prepareSubmitData(this.mapGotoSubmittedEvent);
  }

  public onLocateMeBtnClick(): void {
    navigator.geolocation.getCurrentPosition(
      (position: MapCords) => {
        this.geocodingService.geocodeLocationByCoords({
          lat: position.coords.latitude,
          lon: position.coords.longitude,
        });
      },
      () => {
        this.notificationService.dialogDefault({
          title: 'MAP_GOTO_BLOCK_LOCATE_ME_DENIED_TITLE',
          description: 'MAP_GOTO_BLOCK_LOCATE_ME_DENIED_DESCRIPTION',
          buttons: [this.modalAttributesService.createDialogButton('BTN_CLOSE_HINT')],
        });
      },
    );
  }

  private prepareSubmitData(emitter: EventEmitter<MapGotoBlockForm>): void {
    this.mapGotoForm.prepareSubmitData();
    const formData: MapGotoBlockForm = this.mapGotoForm.childForm.formContent.data as MapGotoBlockForm;
    if (formData.form_location) {
      emitter.emit(formData);
    }
  }

  private subscribeOnLocationInputUpdated(): void {
    this.subscriptions$.push(
      this.geocodingService.locationInputValueUpdated.subscribe(() => {
        this.prepareSubmitData(this.mapGotoSubmittedEvent);
      }),
    );
  }
}
